import CommentListPage from './commentListPage';

export default CommentListPage;
